import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {FormTO} from "../classes/form-to";
import {Observable} from "rxjs";
import {UserFormSearchTO} from "../classes/user-form-search-to";
import {UserSearchTO} from "../classes/user-search-to";
import {ShareTO} from "../classes/share-to";

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) {}

  public findUser(query: String): Observable<Object> {
    return this.http.post('/rest/user/search', query);
  }

  public findUserForm(userFormSearchTO: UserFormSearchTO): Observable<Object> {
    return this.http.post('/rest/user/form/search', userFormSearchTO);
  }

  public saveShare(userSearchTO: UserSearchTO): Observable<Object> {
    return this.http.post('/rest/user/share/save', userSearchTO);
  }

  public revokeShare(shareTO: ShareTO): Observable<Object> {
    return this.http.post('/rest/user/share/revoke', shareTO);
  }

  public revokeShareUser(userSearchTO: UserSearchTO): Observable<Object> {
    return this.http.post('/rest/user/share/revoke', userSearchTO);
  }

}
